import { render, staticRenderFns } from "./profile-card-custom-fields.vue?vue&type=template&id=760ed5e3"
import script from "./profile-card-custom-fields.vue?vue&type=script&lang=js"
export * from "./profile-card-custom-fields.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports